var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.handleResize),expression:"handleResize"}]},[_c('div',{style:(_vm.pageStyle)},[_c('div',{staticClass:"height-view"},[_vm._t("default")],2)]),_c('div',{ref:"bottom"})])}
var staticRenderFns = []

export { render, staticRenderFns }